import * as types from "../actionTypes/modalTypes";
import * as ideaTypes from "../actionTypes/myMatchesActionTypes";

export default function modalReducer(
  state = {
    modalType: null,
    modalProps: {},
  },
  action,
) {
  switch (action.type) {
    case types.SET_MODAL: {
      const { modalType, modalProps } = action.data;
      return {
        modalType,
        modalProps,
      };
    }
    case types.UNSET_MODAL: {
      return {
        modalType: null,
        modalProps: {},
      };
    }
    case ideaTypes.REJECT_IDEA_SUCCESS: {
      return {
        modalType: null,
        modalProps: {},
      };
    }
    default:
      return state;
  }
}
